import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_ACCESSORIES,
    FETCH_ACCESSORIES_FAILURE,
    FETCH_ACCESSORIES_SUCCESS,
    FETCH_DOCUMENTS,
    FETCH_DOCUMENTS_FAILURE,
    FETCH_DOCUMENTS_SUCCESS,
    FETCH_INCENTIVE_OFFER_COMPLEMENTS,
    FETCH_INCENTIVE_OFFER_COMPLEMENTS_FAILURE,
    FETCH_INCENTIVE_OFFER_COMPLEMENTS_SUCCESS,
    FETCH_INVERTER_BRANDS,
    FETCH_INVERTER_BRANDS_FAILURE,
    FETCH_INVERTER_BRANDS_SUCCESS,
    FETCH_INVERTERS,
    FETCH_INVERTERS_FAILURE,
    FETCH_INVERTERS_SUCCESS,
    FETCH_PANEL_BRANDS,
    FETCH_PANEL_BRANDS_FAILURE,
    FETCH_PANEL_BRANDS_SUCCESS,
    FETCH_PANELS,
    FETCH_PANELS_FAILURE,
    FETCH_PANELS_SUCCESS,
    FETCH_PRODUCT,
    FETCH_PRODUCT_FAILURE,
    FETCH_PRODUCT_SUCCESS,
    FETCH_TEMPLATE_CATALOGS,
    FETCH_TEMPLATE_CATALOGS_FAILURE,
    FETCH_TEMPLATE_CATALOGS_SUCCESS,
    INITIALIZE_AUTH_EMAILS_FORM,
    INITIALIZE_FORM,
    OPEN_MODAL_PRODUCT,
    RESET_AUTH_EMAILS_FORM,
    RESET_FORM,
    SAVE_PRODUCT,
    SAVE_PRODUCT_FAILURE,
    SAVE_PRODUCT_SUCCESS,
    SET_IS_OPEN_EMAILS_MODAL,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    accessories: {
        data: { data: [], pagination: {} },
        errors: [],
        isFetching: true,
    },
    documents: {
        data: [],
        errors: [],
        isFetching: true,
    },
    fetchTemplateCatalogs: {
        data: [],
        errors: [],
        isFetching: true,
    },
    incentiveOfferComplements: {
        data: [],
        errors: [],
        isFetching: false,
    },
    initialValues: {},
    initialValuesAuthEmails: {
        auth_emails: [],
    },
    inverterBrands: {
        data: [],
        errors: [],
        isFetching: true,
    },
    inverters: {
        data: {
            data: [],
            pagination: {},
        },
        errors: [],
        isFetching: true,
    },
    isOpenEmailsModal: false,
    panelBrands: {
        data: [],
        errors: [],
        isFetching: true,
    },
    panels: {
        data: {
            data: [],
            pagination: {},
        },
        errors: [],
        isFetching: true,
    },
    product: {
        data: {},
        errors: [],
        isFetching: true,
    },
    productModalIsOpen: false,
    save: {
        errors: [],
        isSaving: true,
    },
};

const slice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_PRODUCT]: (state) => {
            state.product.isFetching = true;
        },
        [FETCH_PRODUCT_FAILURE]: (state, action) => {
            state.product = {
                ...state.product,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PRODUCT_SUCCESS]: (state, action) => {
            state.product = {
                ...state.product,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = {
                ...state.initialValues,
                ...action.payload,
            };
        },
        [OPEN_MODAL_PRODUCT]: (state, action) => {
            state.productModalIsOpen = action.payload;
        },
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
            state.save.errors = [];
        },
        [SAVE_PRODUCT]: (state) => {
            state.save.isSaving = true;
        },
        [SAVE_PRODUCT_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_PRODUCT_SUCCESS]: (state) => {
            state.save.isSaving = false;
        },
        [INITIALIZE_AUTH_EMAILS_FORM]: (state, action) => {
            state.initialValuesAuthEmails = {
                ...state.initialValuesAuthEmails,
                ...action.payload,
            };
        },
        [RESET_AUTH_EMAILS_FORM]: (state) => {
            state.initialValuesAuthEmails =
                INITIAL_STATE.initialValuesAuthEmails;
        },
        [FETCH_ACCESSORIES]: (state) => {
            state.accessories.isFetching = true;
        },
        [FETCH_ACCESSORIES_FAILURE]: (state, action) => {
            state.accessories = {
                ...state.accessories,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ACCESSORIES_SUCCESS]: (state, action) => {
            state.accessories = {
                ...state.accessories,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_DOCUMENTS]: (state) => {
            state.documents.isFetching = true;
        },
        [FETCH_DOCUMENTS_FAILURE]: (state, action) => {
            state.documents = {
                ...state.documents,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_DOCUMENTS_SUCCESS]: (state, action) => {
            state.documents = {
                ...state.documents,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_INCENTIVE_OFFER_COMPLEMENTS]: (state) => {
            state.incentiveOfferComplements = {
                ...state.incentiveOfferComplements,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_INCENTIVE_OFFER_COMPLEMENTS_FAILURE]: (state, action) => {
            state.incentiveOfferComplements = {
                ...state.incentiveOfferComplements,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_INCENTIVE_OFFER_COMPLEMENTS_SUCCESS]: (state, action) => {
            state.incentiveOfferComplements = {
                ...state.incentiveOfferComplements,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_INVERTER_BRANDS]: (state) => {
            state.inverterBrands.isFetching = true;
        },
        [FETCH_INVERTER_BRANDS_FAILURE]: (state, action) => {
            state.inverterBrands = {
                ...state.inverterBrands,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_INVERTER_BRANDS_SUCCESS]: (state, action) => {
            state.inverterBrands = {
                ...state.inverterBrands,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_INVERTERS]: (state) => {
            state.inverters.isFetching = true;
        },
        [FETCH_INVERTERS_FAILURE]: (state, action) => {
            state.inverters = {
                ...state.inverters,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_INVERTERS_SUCCESS]: (state, action) => {
            state.inverters = {
                ...state.inverters,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANEL_BRANDS]: (state) => {
            state.panelBrands.isFetching = true;
        },
        [FETCH_PANEL_BRANDS_FAILURE]: (state, action) => {
            state.panelBrands = {
                ...state.panelBrands,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANEL_BRANDS_SUCCESS]: (state, action) => {
            state.panelBrands = {
                ...state.panelBrands,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANELS]: (state) => {
            state.panels.isFetching = true;
        },
        [FETCH_PANELS_FAILURE]: (state, action) => {
            state.panels = {
                ...state.panels,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANELS_SUCCESS]: (state, action) => {
            state.panels = {
                ...state.panels,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_TEMPLATE_CATALOGS]: (state) => {
            state.fetchTemplateCatalogs.isFetching = true;
        },
        [FETCH_TEMPLATE_CATALOGS_FAILURE]: (state, action) => {
            state.fetchTemplateCatalogs = {
                ...state.fetchTemplateCatalogs,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_TEMPLATE_CATALOGS_SUCCESS]: (state, action) => {
            state.fetchTemplateCatalogs = {
                ...state.fetchTemplateCatalogs,
                data: action.payload,
                isFetching: false,
            };
        },
        [SET_IS_OPEN_EMAILS_MODAL]: (state, action) => {
            state.isOpenEmailsModal = action.payload;
        },
    },
});

export const actions = slice.actions;
export const initialState = INITIAL_STATE;

export default slice.reducer;
